<template>
  <div class="m-copyright-wrapper">
    <div class="info">
      {{ $t('global.copyrightInfo') }}
    </div>
    <div class="items">
      <div v-for="(l, index) in getLinks('6')" :key="l.id" class="item">
        <a :href="l.linkUrl" target="_blank" class="hover-under-line">{{ l.linkTitle }} </a>
        <div v-if="index+1<getLinks('6').length" class="divider-line" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useStoreHooks } from '@/store/hook'

export default defineComponent({
  setup () {
    const { state: storeState } = useStoreHooks()
    const links = storeState.global.footerConfig

    const getLinks = (type: string): any[] => {
      const arr: any[] = []
      links.forEach((l: any) => {
        if (l.areaKind === type) {
          arr.push(l)
        }
      })
      return arr
    }

    return {
      getLinks
    }
  }

})
</script>

<style lang="less" scoped>
 .m-copyright-wrapper {
    width: 100%;
    background: #242630;
    font-size: 1.2rem;
    color: rgba(239, 239, 239, 0.7);
    letter-spacing: 0;
    line-height: 2.2rem;
    font-weight: 400;
    padding: 1.5rem 1.5rem 1rem 1.5rem;
    .items {
      margin-top: 1rem;
      display: flex;
      flex-wrap: wrap;
      .item {
        display: flex;
        align-items: center;
        a {
          color: rgba(239, 239, 239, 0.7);
          cursor: pointer;
        }
      }
      .divider-line {
        width: 0.2rem;
        height: 1.2rem;
        border-right: 0.2rem solid #393C46;
        margin: 0 0.8rem 0 0.8rem;
      }
    }
  }
</style>
